<div class="row m-2">
  @for (providerOffice of providerOffices; track providerOffice) {
    <div class="col-4">
      <app-provider-office [providerOffice]="providerOffice" />
    </div>
  }
</div>
